import { render, staticRenderFns } from "./user-history.vue?vue&type=template&id=5d6faa34&scoped=true&"
import script from "./user-history.vue?vue&type=script&lang=js&"
export * from "./user-history.vue?vue&type=script&lang=js&"
import style0 from "./user-history.vue?vue&type=style&index=0&id=5d6faa34&lang=scss&scoped=true&"
import style1 from "./user-history.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6faa34",
  null
  
)

export default component.exports